import { render, staticRenderFns } from "./MainDetailsWidget.vue?vue&type=template&id=93e6260c"
import script from "./MainDetailsWidget.vue?vue&type=script&lang=js"
export * from "./MainDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports